import styled from 'styled-components';

const sizes = {
  small: {
    width: '24px',
    height: '24px',
    fontSize: '1rem'
  },
  medium: {
    width: '40px',
    height: '40px',
    fontSize: '1.2rem'
  },
  large: {
    width: '64px',
    height: '64px',
    fontSize: '1.5rem'
  }
};

const StyledAvatar = styled.div<{
  size: 'small' | 'medium' | 'large';
  backgroundColor?: string;
  color?: string;
}>`
  width: ${({ size }) => sizes[size!].width};
  height: ${({ size }) => sizes[size!].height};
  font-size: ${({ size }) => sizes[size!].fontSize};
  display: flex;
  overflow: hidden;
  align-items: center;
  flex-shrink: 0;
  line-height: 1;
  user-select: none;
  border-radius: 50%;
  justify-content: center;
  background-color: #668afd;
  color: #fff;
  img {
    width: 100%;
  }
`;

export { StyledAvatar };
